import { Form } from '~/shared/api'
import { WorkflowTransitionType } from '~/interfaces/Workflow'
import { requiredRule, requiredIfRule } from '~/shared/utils/validation'
import type { WorkflowTransitionModel } from '~/model/Workflow'

export default class WorkflowTransitionApplyForm extends Form {
  readonly type: WorkflowTransitionType
  readonly id: string
  protected readonly transition: WorkflowTransitionModel
  readonly transitionId: string
  reason: string = ''

  constructor(type: WorkflowTransitionType, id: string, transition: WorkflowTransitionModel) {
    super()

    this.ignoreKeys.push('transition')

    this.type = type
    this.id = id
    this.transition = transition
    this.transitionId = transition.id

    if (!this.transition.needReason) {
      this.ignoreKeys.push('reason')
    }
  }

  static rules(entity: WorkflowTransitionApplyForm) {
    return {
      type: requiredRule,
      id: requiredRule,
      transitionId: requiredRule,
      reason: requiredIfRule(() => entity.transition.needReason)
    }
  }
}
